// extracted by mini-css-extract-plugin
module.exports = {"mapStyles":"DepartmentMap_mapStyles__2arBs","infoWindow":"DepartmentMap_infoWindow__3fJua"};